import {
  getDefaultSocialPostPlatformForType,
  isCarouselSocialPostType,
  type SocialPostGenerationTaskRequestV3,
} from "@runcheetah/shared";

import type { PlannerBrandPresence, PlannerGenerationMode, PlannerPostType } from "./constants";

export interface BuildSocialPostPlannerRequestInput {
  prompt: string;
  postType: PlannerPostType;
  brandPresence: PlannerBrandPresence;
  generationMode: PlannerGenerationMode;
  layoutTemplateId: string;
  carouselFormatKey: string;
}

export const buildSocialPostPlannerRequest = ({
  prompt,
  postType,
  brandPresence,
  generationMode,
  layoutTemplateId,
  carouselFormatKey,
}: BuildSocialPostPlannerRequestInput): SocialPostGenerationTaskRequestV3 => {
  const request: SocialPostGenerationTaskRequestV3 = {
    type: "social_post.request",
    version: 3,
    sourceBrief: { version: 1, origin: "direct", direction: prompt.trim() },
    platform: getDefaultSocialPostPlatformForType(postType) ?? "instagram",
    postType,
    variantCount: 1,
    brandPresence,
  };

  if (isCarouselSocialPostType(postType)) {
    if (carouselFormatKey) {
      request.carouselFormatKey = carouselFormatKey;
    }

    return request;
  }

  if (generationMode !== "auto") {
    request.assetCreationFlow = generationMode;
  }

  if (generationMode === "template" && layoutTemplateId) {
    request.layoutTemplateId = layoutTemplateId;
  }

  return request;
};
